'use es6';

import keyMirror from 'react-utils/keyMirror';
/**
 * Type enum for Portal Copy getDependencies requests.
 */

export default Object.freeze(keyMirror({
  LAYOUT: null,
  EXTENSION_RESOURCE: null,
  CUSTOM_WIDGET: null
}));